var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBonusPayout = function SvgBonusPayout(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F4B70C",
    opacity: 0.2,
    rx: 16,
    transform: "rotate(180 16 16)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D43",
    d: "M8.214 2.985C8.11 2.852 5.633-.253 3.677.017 2.984.113 2.45.6 2.09 1.466c-.496 1.193-.538 2.164-.123 2.884.517.896 1.54 1.04 1.584 1.047l.035.002h4.42c.147 0 .265-.118.265-.264V3.148c0-.059-.02-.117-.057-.163zM15.91 1.466C15.55.6 15.016.113 14.323.017c-1.955-.27-4.433 2.835-4.537 2.968-.037.046-.057.104-.057.163v1.987c0 .146.118.264.264.264h4.421c.012 0 .023 0 .035-.002.043-.006 1.067-.15 1.584-1.047.415-.72.373-1.69-.123-2.884z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D62D2D",
    d: "M8.007 4.184H3.586c-.012 0-.023-.001-.035-.003-.043-.005-1.067-.15-1.584-1.046-.1-.173-.172-.36-.22-.562-.13.7-.058 1.294.22 1.777.517.896 1.54 1.04 1.584 1.047l.035.002h4.42c.147 0 .265-.118.265-.264V3.92c0 .145-.118.264-.264.264zM16.033 3.135c-.517.896-1.54 1.04-1.584 1.046-.012.002-.023.003-.035.003h-4.42c-.147 0-.265-.119-.265-.264v1.215c0 .146.118.264.264.264h4.421c.012 0 .023 0 .035-.002.043-.006 1.067-.15 1.584-1.047.278-.483.35-1.078.22-1.777-.048.201-.12.389-.22.562z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D62D2D",
    d: "M9.993 2.884H8.007c-.146 0-.264.118-.264.264v1.987c0 .146.118.264.264.264h1.986c.146 0 .264-.118.264-.264V3.148c0-.146-.118-.264-.264-.264z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E1219",
    d: "M7.743 4.184v.95c0 .147.118.265.264.265h1.986c.146 0 .264-.118.264-.264v-.951H7.743z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD039",
    d: "M16.401 7.48H1.6c-.146 0-.264.118-.264.264v7.699c0 .633.515 1.148 1.148 1.148h13.034c.633 0 1.148-.515 1.148-1.148V7.744c0-.146-.118-.264-.264-.264z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B70C",
    d: "M16.401 7.48H1.6c-.146 0-.264.118-.264.264V8.88h15.33V7.744c0-.146-.118-.264-.264-.264z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF65",
    d: "M17.736 4.87H.264C.118 4.87 0 4.99 0 5.136v2.61c0 .145.118.263.264.263h17.472c.146 0 .264-.118.264-.264v-2.61c0-.145-.118-.263-.264-.263z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD2C",
    d: "M0 6.793v.951c0 .146.118.264.264.264h17.472c.146 0 .264-.118.264-.264v-.95H0z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D43",
    d: "M10.306 4.87H7.694c-.146 0-.264.119-.264.265v11.191c0 .146.118.265.264.265h2.612c.146 0 .264-.119.264-.265V5.135c0-.146-.118-.264-.264-.264z",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D62D2D",
    d: "M10.306 4.87h-.95v11.72h.95c.146 0 .264-.118.264-.264V5.135c0-.146-.118-.264-.264-.264z",
    transform: "translate(7 7)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBonusPayout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bonus_payout.27bcf7ab.svg";
export { ForwardRef as ReactComponent };